import { WppPillGroup } from '@platform-ui-kit/components-library-react'
import { useEffect, useRef, useState } from 'react'
import { useMeasure } from 'react-use'

import { RemoveFilter, TagLabel } from 'pages/applications/list/components/filterTags/ApplicationFiltersTags'
import { getTagsAmountForLine } from 'pages/applications/list/utils'
import { CategoryCode } from 'types/applications/application'
import { ApplicationCategory, ApplicationCategoryLogo } from 'types/applications/enums'
import { Flex } from 'ui-base/flex/Flex'

import * as S from 'pages/applications/list/components/filterTags/ApplicationFiltersTags.styled'

type Props = {
  tags: TagLabel[]
  onClose: RemoveFilter
  shown: boolean
  setTagAmount: (amount: number) => void
}

export const ApplicationLineOfTags = ({ tags, onClose, shown, setTagAmount }: Props) => {
  const [localTags, setLocalTags] = useState<TagLabel[]>([])
  const [lineRef, { width }] = useMeasure<HTMLDivElement>()
  const hiddenRef = useRef<HTMLWppPillGroupElement | null>(null)

  useEffect(() => {
    const children = hiddenRef.current ? hiddenRef.current?.children[0].children : []
    const amount = getTagsAmountForLine(Array.from(children) as HTMLElement[])
    setLocalTags(tags.slice(0, amount))
    setTagAmount(amount)
  }, [width, tags, hiddenRef, setTagAmount])

  return (
    <S.LineOfTagsWrapper ref={lineRef} className={shown ? 'shown' : 'hidden'} data-testid="line-of-tags-wrapper">
      <S.HiddenTags ref={hiddenRef} type="display">
        <Flex wrap="wrap" align="center" gap={4}>
          {tags.map(tag => (
            <S.Tag key={tag.code} label={tag.label} type="display" removable>
              {tag.category === 'categories' && (
                <S.CategoryTagImage
                  slot="icon-start"
                  src={ApplicationCategoryLogo[tag.code as ApplicationCategory]}
                  alt="category-logo"
                />
              )}
            </S.Tag>
          ))}
        </Flex>
      </S.HiddenTags>
      <WppPillGroup type="display">
        <Flex wrap="wrap" align="center" gap={4} data-testid="line-of-tags">
          {localTags.map(tag => (
            <S.LocalTag
              key={tag.code}
              label={tag.label}
              onWppClose={() => onClose(tag.category as CategoryCode, tag.code)}
              data-testid={`${tag.label}-tag`}
              removable
            >
              {tag.category === 'categories' && (
                <S.CategoryTagImage
                  slot="icon-start"
                  src={ApplicationCategoryLogo[tag.code as ApplicationCategory]}
                  alt="category-logo"
                />
              )}
            </S.LocalTag>
          ))}
        </Flex>
      </WppPillGroup>
    </S.LineOfTagsWrapper>
  )
}
